import React, {useState} from 'react'
import {Table} from 'react-bootstrap'
import Lightbox from 'react-image-lightbox'
import k1utils from '../../../../util/k1utils'

export function OrderDesign({data}) {
  const [isOpen, setIsOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)
  const imgList = data
    .filter((item) => item.t_fileidx !== 0)
    .map((item) => k1utils.toBigFileUrl(item.t_fileidx))
  return (
    <Table striped bordered hover>
      <thead className='thead-dark'>
        <tr>
          <th style={{width: '28%'}}>세부 디자인</th>
          <th>내용</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((item, i) => {
            if (item.t_fileidx === 0 && item.contents === '') return false
            return (
              <tr key={'order_ref-' + i}>
                <td>{item.t_fileidx === 0 ? '디자인설명' : '참고 이미지'}</td>
                <td>
                  {item.t_fileidx !== 0 ? (
                    <div className='symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center'>
                      <div
                        className='symbol-label'
                        style={{backgroundImage: `url(${k1utils.toSmallFileUrl(item.t_fileidx)}`}}
                        onClick={() => {
                          setIsOpen(true)
                          setPhotoIndex(i - 1)
                        }}
                      ></div>
                      {isOpen && (
                        <Lightbox
                          mainSrc={imgList[photoIndex]}
                          prevSrc={imgList[photoIndex - 1]}
                          nextSrc={imgList[photoIndex + 1]}
                          onMoveNextRequest={() => setPhotoIndex(photoIndex + 1)}
                          onMovePrevRequest={() => setPhotoIndex(photoIndex - 1)}
                          onCloseRequest={() => setIsOpen(false)}
                          clickOutsideToClose={false}
                        />
                      )}
                    </div>
                  ) : (
                    <div className='d-flex align-items-center py-lg-0 py-2'>
                      <div className='d-flex flex-column text-left'>
                        <span
                          className='text-dark-75 font-weight-bolder text-hover-primary font-size-lg'
                          style={{whiteSpace: 'pre-wrap'}}
                        >
                          {item.contents}
                        </span>
                        {/*<span className="text-muted font-weight-bolder font-size-sm">*/}
                        {/*</span>*/}
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            )
            //         return (
            //             <div className="d-flex flex-wrap align-items-center border px-1" key={"order_ref-" + i}>
            //                 {/* begin::Title */}
            //                 <div className="d-flex flex-column flex-grow-1 my-lg-0 py-2 pr-3">
            //                     <span
            //                         className="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
            //                     >
            //                         {item.t_fileidx === 0 ? "디자인설명" : "참고 이미지"}
            //                     </span>
            //                 </div>
            //                 {/* end::Title */}
            //
            //                 {/* begin::Info */}
            //                 {item.t_fileidx !== 0 ?
            //                     <div
            //                         className="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
            //                         <div
            //                             className="symbol-label"
            //                             style={{backgroundImage: `url(${process.env.REACT_APP_API_SERVER_URL}/front/file2?file_idx=${item.t_fileidx}&type=SMALL)`}}
            //                         ></div>
            //                     </div>
            //                     :
            //                     <div className="d-flex align-items-center py-lg-0 py-2">
            //                         <div className="d-flex flex-column text-right">
            //                             <span
            //                                 className="text-dark-75 font-weight-bolder text-hover-primary font-size-lg">
            //                                 {item.contents}
            //                             </span>
            //                             <span className="text-muted font-weight-bolder font-size-sm">
            //                         </span>
            //                         </div>
            //                     </div>
            //                 }
            //                 {/* end::Info */}
            //             </div>
            //         )
          })}
      </tbody>
    </Table>
  )
}
